import { render, staticRenderFns } from "./CarouselView.vue?vue&type=template&id=53e0adac"
import script from "./CarouselView.vue?vue&type=script&lang=js"
export * from "./CarouselView.vue?vue&type=script&lang=js"
import style0 from "./CarouselView.vue?vue&type=style&index=0&id=53e0adac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports